// <auto-generated>
// This file is automatically generated from DSL.
// Do not modify this file directly. Changes will be overwritten.
// Generated: 2026-10-19T08:01:51.129Z
// </auto-generated>

import { lazy, Suspense } from 'react';

const AgreementListView = lazy(() => import('@/forestry/AgreementListView').then(m => ({ default: m.AgreementListView })));
const AgreementDetailView = lazy(() => import('@/forestry/AgreementDetailView').then(m => ({ default: m.AgreementDetailView })));
const CalculationComponentListView = lazy(() => import('@/forestry/CalculationComponentListView').then(m => ({ default: m.CalculationComponentListView })));
const CalculationComponentDetailView = lazy(() => import('@/forestry/CalculationComponentDetailView').then(m => ({ default: m.CalculationComponentDetailView })));
const CalculationTemplateListView = lazy(() => import('@/forestry/CalculationTemplateListView').then(m => ({ default: m.CalculationTemplateListView })));
const CalculationTemplateDetailView = lazy(() => import('@/forestry/CalculationTemplateDetailView').then(m => ({ default: m.CalculationTemplateDetailView })));
const ContractListView = lazy(() => import('@/forestry/ContractListView').then(m => ({ default: m.ContractListView })));
const ContractDetailView = lazy(() => import('@/forestry/ContractDetailView').then(m => ({ default: m.ContractDetailView })));
const CostTypeListView = lazy(() => import('@/forestry/CostTypeListView').then(m => ({ default: m.CostTypeListView })));
const CostTypeDetailView = lazy(() => import('@/forestry/CostTypeDetailView').then(m => ({ default: m.CostTypeDetailView })));
const LoadObservationListView = lazy(() => import('@/forestry/LoadObservationListView').then(m => ({ default: m.LoadObservationListView })));
const LoadObservationDetailView = lazy(() => import('@/forestry/LoadObservationDetailView').then(m => ({ default: m.LoadObservationDetailView })));
const OrganizationListView = lazy(() => import('@/forestry/OrganizationListView').then(m => ({ default: m.OrganizationListView })));
const OrganizationDetailView = lazy(() => import('@/forestry/OrganizationDetailView').then(m => ({ default: m.OrganizationDetailView })));
const PreCalculationListView = lazy(() => import('@/forestry/PreCalculationListView').then(m => ({ default: m.PreCalculationListView })));
const PreCalculationDetailView = lazy(() => import('@/forestry/PreCalculationDetailView').then(m => ({ default: m.PreCalculationDetailView })));
const PriceAreaAssortmentListView = lazy(() => import('@/forestry/PriceAreaAssortmentListView').then(m => ({ default: m.PriceAreaAssortmentListView })));
const PriceAreaAssortmentDetailView = lazy(() => import('@/forestry/PriceAreaAssortmentDetailView').then(m => ({ default: m.PriceAreaAssortmentDetailView })));
const PriceDimensionListView = lazy(() => import('@/forestry/PriceDimensionListView').then(m => ({ default: m.PriceDimensionListView })));
const PriceDimensionDetailView = lazy(() => import('@/forestry/PriceDimensionDetailView').then(m => ({ default: m.PriceDimensionDetailView })));
const PriceDimensionClassCombinationListView = lazy(() => import('@/forestry/PriceDimensionClassCombinationListView').then(m => ({ default: m.PriceDimensionClassCombinationListView })));
const PriceDimensionClassCombinationDetailView = lazy(() => import('@/forestry/PriceDimensionClassCombinationDetailView').then(m => ({ default: m.PriceDimensionClassCombinationDetailView })));
const WorkorderListView = lazy(() => import('@/forestry/WorkorderListView').then(m => ({ default: m.WorkorderListView })));
const WorkorderDetailView = lazy(() => import('@/forestry/WorkorderDetailView').then(m => ({ default: m.WorkorderDetailView })));

/**
 * Forestry Module Routes
 */
export const forestryRoutes = [
{ path: '/forestry/agreements',
element: <Suspense><AgreementListView /></Suspense> },
{ path: '/forestry/agreements/:id',
element: <Suspense><AgreementDetailView /></Suspense> },
{ path: '/forestry/agreements/template/new',
element: <Suspense><AgreementDetailView mode="template" /></Suspense> },
{ path: '/forestry/agreements/template/:templateId',
element: <Suspense><AgreementDetailView mode="template" /></Suspense> },
{ path: '/forestry/calculationcomponents',
element: <Suspense><CalculationComponentListView /></Suspense> },
{ path: '/forestry/calculationcomponents/:id',
element: <Suspense><CalculationComponentDetailView /></Suspense> },
{ path: '/forestry/calculationcomponents/template/new',
element: <Suspense><CalculationComponentDetailView mode="template" /></Suspense> },
{ path: '/forestry/calculationcomponents/template/:templateId',
element: <Suspense><CalculationComponentDetailView mode="template" /></Suspense> },
{ path: '/forestry/calculationtemplates',
element: <Suspense><CalculationTemplateListView /></Suspense> },
{ path: '/forestry/calculationtemplates/:id',
element: <Suspense><CalculationTemplateDetailView /></Suspense> },
{ path: '/forestry/calculationtemplates/template/new',
element: <Suspense><CalculationTemplateDetailView mode="template" /></Suspense> },
{ path: '/forestry/calculationtemplates/template/:templateId',
element: <Suspense><CalculationTemplateDetailView mode="template" /></Suspense> },
{ path: '/forestry/contracts',
element: <Suspense><ContractListView /></Suspense> },
{ path: '/forestry/contracts/:id',
element: <Suspense><ContractDetailView /></Suspense> },
{ path: '/forestry/contracts/template/new',
element: <Suspense><ContractDetailView mode="template" /></Suspense> },
{ path: '/forestry/contracts/template/:templateId',
element: <Suspense><ContractDetailView mode="template" /></Suspense> },
{ path: '/forestry/costtypes',
element: <Suspense><CostTypeListView /></Suspense> },
{ path: '/forestry/costtypes/:id',
element: <Suspense><CostTypeDetailView /></Suspense> },
{ path: '/forestry/loadobservations',
element: <Suspense><LoadObservationListView /></Suspense> },
{ path: '/forestry/loadobservations/:id',
element: <Suspense><LoadObservationDetailView /></Suspense> },
{ path: '/forestry/organizations',
element: <Suspense><OrganizationListView /></Suspense> },
{ path: '/forestry/organizations/:id',
element: <Suspense><OrganizationDetailView /></Suspense> },
{ path: '/forestry/organizations/template/new',
element: <Suspense><OrganizationDetailView mode="template" /></Suspense> },
{ path: '/forestry/organizations/template/:templateId',
element: <Suspense><OrganizationDetailView mode="template" /></Suspense> },
{ path: '/forestry/precalculations',
element: <Suspense><PreCalculationListView /></Suspense> },
{ path: '/forestry/precalculations/:id',
element: <Suspense><PreCalculationDetailView /></Suspense> },
{ path: '/forestry/priceareaassortments',
element: <Suspense><PriceAreaAssortmentListView /></Suspense> },
{ path: '/forestry/priceareaassortments/:id',
element: <Suspense><PriceAreaAssortmentDetailView /></Suspense> },
{ path: '/forestry/pricedimensions',
element: <Suspense><PriceDimensionListView /></Suspense> },
{ path: '/forestry/pricedimensions/:id',
element: <Suspense><PriceDimensionDetailView /></Suspense> },
{ path: '/forestry/pricedimensions/template/new',
element: <Suspense><PriceDimensionDetailView mode="template" /></Suspense> },
{ path: '/forestry/pricedimensions/template/:templateId',
element: <Suspense><PriceDimensionDetailView mode="template" /></Suspense> },
{ path: '/forestry/pricedimensionclasscombinations',
element: <Suspense><PriceDimensionClassCombinationListView /></Suspense> },
{ path: '/forestry/pricedimensionclasscombinations/:id',
element: <Suspense><PriceDimensionClassCombinationDetailView /></Suspense> },
{ path: '/forestry/workorders',
element: <Suspense><WorkorderListView /></Suspense> },
{ path: '/forestry/workorders/:id',
element: <Suspense><WorkorderDetailView /></Suspense> },
{ path: '/forestry/workorders/template/new',
element: <Suspense><WorkorderDetailView mode="template" /></Suspense> },
{ path: '/forestry/workorders/template/:templateId',
element: <Suspense><WorkorderDetailView mode="template" /></Suspense> }
];
